import { lazy, Suspense, type ReactElement } from 'react';
import {
  parseConsentPath,
  parsePayPath,
  parseSurveyPath,
  PRIVACY_PATH,
  PUBLIC_PATHS,
} from './routes.js';

export { PUBLIC_PATHS };

const PublicBookingPage = lazy(() =>
  import('../pages/PublicBooking.js').then((m) => ({ default: m.PublicBookingPage })),
);
const BookingPosterPage = lazy(() =>
  import('../pages/BookingPoster.js').then((m) => ({ default: m.BookingPosterPage })),
);
const KioskPage = lazy(() =>
  import('../pages/KioskStart.js').then((m) => ({ default: m.KioskPage })),
);
const PublicPaymentPage = lazy(() =>
  import('../pages/PublicPayment.js').then((m) => ({ default: m.PublicPaymentPage })),
);
const PublicConsentPage = lazy(() =>
  import('../pages/PublicConsent.js').then((m) => ({ default: m.PublicConsentPage })),
);
const PublicSurveyPage = lazy(() =>
  import('../pages/PublicSurvey.js').then((m) => ({ default: m.PublicSurveyPage })),
);
const PrivacyPolicyPage = lazy(() =>
  import('../pages/PrivacyPolicy.js').then((m) => ({ default: m.PrivacyPolicyPage })),
);

/**
 * Kabuk dışında çizilecek sayfa. Ödeme bağlantısı sabit bir yol DEĞİLDİR (`/odeme/<belirteç>`),
 * bu yüzden birleşim ayrı bir kolla genişler; yolun kendisi `routes.ts`te, `/odeme` dizesi ise
 * `@dentos/contracts`ın `PUBLIC_PAY_PATH`inde tek kaynak olarak durur (H20).
 */
export type PublicRoute =
  | { kind: (typeof PUBLIC_PATHS)[number] }
  | { kind: 'pay'; token: string }
  | { kind: 'consent'; token: string }
  | { kind: 'survey'; token: string };

export function matchPublicPath(pathname: string): PublicRoute | null {
  const clean = pathname.replace(/\/+$/, '') || '/';
  const fixed = PUBLIC_PATHS.find((p) => p === clean);
  if (fixed) return { kind: fixed };
  const pay = parsePayPath(clean);
  if (pay !== null) return { kind: 'pay', token: pay.token };
  const consent = parseConsentPath(clean);
  if (consent !== null) return { kind: 'consent', token: consent.token };
  const survey = parseSurveyPath(clean);
  return survey === null ? null : { kind: 'survey', token: survey.token };
}

export function PublicEntry({ route }: { route: PublicRoute }): ReactElement {
  return (
    <Suspense fallback={<div className="public-loading">Yükleniyor…</div>}>
      {/* Belirteçli kol ÖNCE sorulur: kalan sabit yollar ancak böyle daraltılabilir. */}
      {route.kind === 'pay' ? (
        <PublicPaymentPage token={route.token} />
      ) : route.kind === 'consent' ? (
        <PublicConsentPage token={route.token} />
      ) : route.kind === 'survey' ? (
        <PublicSurveyPage token={route.token} />
      ) : route.kind === PRIVACY_PATH ? (
        <PrivacyPolicyPage />
      ) : route.kind === '/randevu/afis' ? (
        <BookingPosterPage />
      ) : route.kind === '/randevu' ? (
        <PublicBookingPage />
      ) : (
        <KioskPage />
      )}
    </Suspense>
  );
}
